// extracted by mini-css-extract-plugin
module.exports = {"container":"completed-form-page-module__container--Q9xgi","message":"completed-form-page-module__message--BiwP7","goToMyAccount":"completed-form-page-module__goToMyAccount--QrYio"};